let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("5GYyU")).then(() => parcelRequire('cCn8A'));